// oxlint-disable-next-line endla/no-compiler-opt-out -- Existing code
"use no memo";

export const PENDING_NAME_SUFFIX = " (pending)";
export const AUTO_PLACED_GIS_DATA_LAYER = "auto-placed";

// testing / DOM access
export const PIPELINE_CUSTOM_CODE_EXECUTION_SUCCESS = "Success running user defined function";
export const PIPELINE_NETWORK_SELECTOR = "pipeline-network-selector";
export const ADD_AUTO_LPDS = "add-auto-lpds";
export const AUTO_FITTINGS_ALLOCATION_EDIT_CODE = "auto-fittings-allocation-edit-code";
export const AUTO_FITTINGS_ALLOCATION_LPD_EDIT_CODE = "auto-fittings-allocation-lpd-edit-code";

export const SHOW_DOWNHILL_ANNOTATIONS = "show-downhill-annotations";
export const SHOW_UPHILL_ANNOTATIONS = "show-uphill-annotations";

export const ELEVATION_PROFILE_PLOT_ID = "elevation-profile-plot";

export const PIPELINES_LOADER_OFF = "pipelines-loader";
